"use client";

import { SpinnerIcon, useTimeout } from "@hyperlane-xyz/widgets";
import { PropsWithChildren, useState } from "react";
import { useReadyMultiProvider } from "./chains/hooks";

const INIT_TIMEOUT = 3_000;

export function WarpContextInitGate({ children }: PropsWithChildren<unknown>) {
  const isWarpContextReady = !!useReadyMultiProvider();

  const [isTimedOut, setIsTimedOut] = useState(false);
  useTimeout(() => setIsTimedOut(true), INIT_TIMEOUT);

  if (!isWarpContextReady) {
    if (isTimedOut) {
      return <>{children}</>;
    } else {
      return (
        <div
          style={{
            display: "flex",
            minHeight: "100vh",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <SpinnerIcon
            width={40}
            height={40}
            color={"#666"}
            style={{ opacity: 0.5 }}
          />
        </div>
      );
    }
  }

  return <>{children}</>;
}
